import { ITicketsBalances } from "../../../model/user-info.interface";
import { IBalances } from "../../../types/balances";

const TICKET_KEYS: (keyof ITicketsBalances)[] = [
    "regularTickets",
    "rareTickets",
    "epicTickets",
    "legendaryTickets",
];

export const resolveDrawCostCurrency = (cost: IBalances): keyof ITicketsBalances | null => {
    for (const key of TICKET_KEYS) {
        const value = cost[key];
        if (value > 0) {
            return key;
        }
    }
    return null;
};
